import { forwardRef } from "react";
import NextLink from "next/dist/client/link";

export * from "next/dist/client/link";

type Props = React.ComponentProps<typeof NextLink>;

// next.config.js points every `import Link from "next/link"` here. Next 12 prefetches each link as
// soon as it scrolls into view, and it runs the page's code too: the menu alone pulled in fifteen
// pages (Backtester, Alerts, Charts...) during every page load, and a table of stocks prefetched
// the stock page once per row. With prefetch off by default a page's code still loads early, on
// hover or touchstart (Next does that even with prefetch={false}), just not during the load.
// Pass prefetch explicitly to opt a link back in.
const Link = forwardRef<HTMLAnchorElement, Props>(function Link({ prefetch = false, ...rest }, ref) {
    return <NextLink {...rest} prefetch={prefetch} ref={ref} />;
});

export default Link;
